import useTable from '../../components/useTable'
import { User } from '../../providers/ClientProvider/client/services/users/types'
import { useFindQuery } from '../../query'
import { useCallback } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import { appRoutes } from '../../containers/Router/routes'

const useUsers = () => {
  const { query, onTableChange, currentSort, currentPage } = useTable<User>()

  const history = useHistory()

  const { data: usersRes, status } = useFindQuery('users', query)

  const handleOnRowClick = useCallback((id: string): void => {
    history.push(
      generatePath(appRoutes.userEdit.path, {
        id: id
      })
    )
  }, [])

  const onCreateNewUser = useCallback((): void => {
    history.push(appRoutes.userCreate.path)
  }, [])

  return {
    users: usersRes?.data,
    loading: status === 'loading',
    total: usersRes?.total || 0,
    onTableChange,
    currentSort,
    currentPage,
    handleOnRowClick,
    onCreateNewUser
  }
}
export default useUsers
